import { Link, useNavigate } from "react-router-dom";

export default function VehicleMaintenancesTable() {
  const navigate = useNavigate();

  const handleNavigate = (buscode) => {
    navigate(`/${buscode}`);
  };

  const data = [
    { id: 1, buscode: "MH20ER4534", maintenancetask: "Servicing", scheduleduration: "4", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2024", typeoftask: "Instant" },
    { id: 2, buscode: "MH02MN0098", maintenancetask: "Servicing", scheduleduration: "4", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2024", typeoftask: "Instant" },
    { id: 3, buscode: "MH03AS3945", maintenancetask: "Servicing", scheduleduration: "24", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2024", typeoftask: "Instant" },
    { id: 4, buscode: "MH04KL0921", maintenancetask: "Servicing", scheduleduration: "45", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 5, buscode: "MH05MH5932", maintenancetask: "Servicing", scheduleduration: "44", startdate: "Thu Dec 23 1974", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 6, buscode: "MH06MJ4321", maintenancetask: "Servicing", scheduleduration: "4", startdate: "Mon Jan 11 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 7, buscode: "MH07ND4567", maintenancetask: "Servicing", scheduleduration: "5", startdate: "Wed Mar 30 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 8, buscode: "MH08KK4909", maintenancetask: "Servicing", scheduleduration: "3", startdate: "Wed Mar 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
    { id: 9, buscode: "MH11KL0008", maintenancetask: "Servicing", scheduleduration: "11", startdate: "Sat Jun 20 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
    { id: 10, buscode: "MH20UI3424", maintenancetask: "Servicing", scheduleduration: "12", startdate: "Mon Jun 22 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 11, buscode: "MH20SQ9021", maintenancetask: "HGD", scheduleduration: "34", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
    { id: 12, buscode: "MH23MK8245", maintenancetask: "Cluch Wire", scheduleduration: "13", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 13, buscode: "MH24NF5321", maintenancetask: "Break Linear", scheduleduration: "55", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
    { id: 14, buscode: "MH22PQ4441", maintenancetask: "Engine Oil", scheduleduration: "12", startdate: "Tue Jun 23 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 15, buscode: "MH12EE2323", maintenancetask: "Battery", scheduleduration: "34", startdate: "Thu Jan 1 1970", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 16, buscode: "MH11FG9090", maintenancetask: "Oil Seal", scheduleduration: "6", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
    { id: 17, buscode: "MH20UI1221", maintenancetask: "Speed Meter", scheduleduration: "9", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 18, buscode: "MH20EE0890", maintenancetask: "Tyer", scheduleduration: "22", startdate: "Fri Aug 30 2024", nextdate: "Mon May 12 2025", typeoftask: "Scheduled" },
    { id: 19, buscode: "MH20SQ0987", maintenancetask: "Servicing", scheduleduration: "21", startdate: "Wed Mar 30 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
    { id: 20, buscode: "MH21XQ0087", maintenancetask: "Servicing", scheduleduration: "21", startdate: "Wed Mar 30 2022", nextdate: "Mon May 12 2025", typeoftask: "Instant" },
  ];

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Maintenances</h4>
        <div className="yc-header-actions">
          <Link to="/accountant/createvehiclemaintenance" className="btn btn-primary">
            Create Vehicle Maintenance
          </Link>
          <div className="dropdown">
            <button
              id="btnGroupDropExport"
              type="button"
              className="btn btn-primary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
              <li><a className="dropdown-item" href="#">Save as PDF</a></li>
              <li><a className="dropdown-item" href="#">Save as CSV</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select className="form-select">
            <option>Bus Number</option>
            <option>MH20EE3948</option>
            <option>MH21RE4890</option>
          </select>
          <input type="text" className="form-control" placeholder="Maintenance Task" />
          <button type="button" className="btn btn-primary">Clear</button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-8">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Bus Code</div>
            <div className="yc-list-cell">Maintenance Task</div>
            <div className="yc-list-cell">Schedule Duration (H)</div>
            <div className="yc-list-cell">Start Date</div>
            <div className="yc-list-cell">Next Due Date</div>
            <div className="yc-list-cell">Type of Task</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {data.map((row, idx) => (
            <div key={row.id} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-8">
                <div className="yc-list-cell">{idx + 1}</div>
                <div className="yc-list-cell">{row.buscode}</div>
                <div className="yc-list-cell">{row.maintenancetask}</div>
                <div className="yc-list-cell">{row.scheduleduration}</div>
                <div className="yc-list-cell">{row.startdate}</div>
                <div className="yc-list-cell">{row.nextdate}</div>
                <div className="yc-list-cell">{row.typeoftask}</div>
                <div className="yc-list-cell yc-list-cell--actions">
                  <button
                    type="button"
                    className="yc-action-icon"
                    onClick={() => handleNavigate(row.buscode)}
                    title="View"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <Link
                    to="/accountant/updatevehiclemaintenance"
                    className="yc-action-icon"
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Link>
                  <button
                    type="button"
                    className="yc-action-icon yc-action-icon--danger"
                    onClick={() => handleNavigate(row.buscode)}
                    title="Delete"
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
